<template>
    <div class="fill-height">
        <v-row class="fill-height ma-0" justify="center" align="center">
            <v-col cols="12" sm="8" md="6" lg="4">
                <v-card class="pa-10 rounded-3xl" elevation="0" color="surface">
                    <component :is="currentView" @change-view="changeView" />
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import LoginForm from "./components/LoginForm.vue";
import RecoveryForm from "./components/RecoveryForm.vue";
import RegisterForm from "./components/RegisterForm.vue";

export default {
    components: {
        LoginForm,
        RecoveryForm,
        RegisterForm
    },
    data() {
        return {
            currentView: this.$route.query.view === "register" ? "RegisterForm" : "LoginForm"
        };
    },
    watch: {
        "$route.query.view"(view) {
            this.currentView = view === "register" ? "RegisterForm" : "LoginForm";
        }
    },
    methods: {
        changeView(view) {
            this.currentView = view;
        }
    }
};
</script>
